export const prizeTypes = {
    energy: 'energy',
    case: 'case',
    coin: 'coin',
    depositCode: 'deposit-code',
    skinCode: 'skin-code',
    wheelCode: 'wheel-code',
    depositFreeCase: 'deposit-free-case',
    xpCode: 'xp-code',
    balanceCode: 'balance-code',
    gift: 'gift',
}
